var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00005 9.51338L8.76671 11.1867C9.27338 11.4934 9.89338 11.04 9.76005 10.4667L9.02672 7.32005L11.4734 5.20005C11.92 4.81338 11.68 4.08005 11.0934 4.03338L7.87338 3.76005L6.61338 0.786714C6.38671 0.246714 5.61338 0.246714 5.38671 0.786714L4.12671 3.75338L0.906715 4.02671C0.320048 4.07338 0.0800484 4.80671 0.526715 5.19338L2.97338 7.31338L2.24005 10.46C2.10672 11.0334 2.72671 11.4867 3.23338 11.18L6.00005 9.51338Z",
    fill: "#9C27B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlIcon);
export default __webpack_public_path__ + "static/media/tlIcon.7f68bc0d241b2301ebc55d63c7e2b145.svg";
export { ForwardRef as ReactComponent };